// extracted by mini-css-extract-plugin
module.exports = {"socialIconsList":"styles_socialIconsList__Ps5Rn","activeIcon":"styles_activeIcon__E_gpn","pulse":"styles_pulse__MnGtm"};